// ---
import React from "react";
import {connect} from "react-redux";
import {FieldArray, formValueSelector, reduxForm} from "redux-form";
import {ff, form, Icon, Loader} from "@mc/mc-legacy";
import {Col, Row} from "@mc/ui-v3";
import "./ChangeApproversForm.scss";
import {Button} from "@mc/react-core";

const Form = form.Form;
const FormBody = form.FormBody;
const FormActions = form.FormActions;

const validate = (formData) => {
    const errors = {} as any;
    if (formData.steps) {
        formData.steps.forEach((step, indexStep) => {
            if (step.approvers) {
                step.approvers.forEach((approver, indexApp) => {
                    if (!approver.pracovnikId) {
                        if (!errors.steps) {
                            errors.steps = [];
                        }
                        if (!errors.steps[indexStep]) {
                            errors.steps[indexStep] = {
                                approvers: []
                            }
                        }
                        errors.steps[indexStep].approvers[indexApp] = {
                            pracovnikId: "Je třeba vyplnit schvalovatele"
                        }
                    }
                })
            }
        });
    }
    console.warn(errors);
    return errors;
};

/**
 * Formulář změny schvalujících.
 */
class ChangeApproversForm extends React.Component {
    static formName = "changeApproversForm";

    constructor(props) {
        super(props);
    }

    stepDone(approvers) {
        const isDone = approvers.find(element => element.approved === false)
        return isDone == undefined ? true : false;
    }

    renderApprovers = ({fields, step}) => {
        const {pracovnici} = this.props;

        console.log(this.props);

        return (
            <div className="step-approvers">
                {fields.map((field, index) => {
                    const approver = step.approvers[index];
                    const disabled = approver.approved;
                    const add = (index + 1) === fields.length;
                    const canRemove = fields.length > 1;
                    return <Row noGutters className="approver" key={index}>
                        <Col>
                            <ff.Autocomplete
                                name={field + ".pracovnikId"}
                                items={pracovnici}
                                useIdAsValue={true}
                                disabled={disabled}
                                label={false}
                                renderItemContent={(item, name) => {
                                    if (name && name.length > 0) {
                                        return (
                                            <span title={item.title ? item.title : ""} className="item-text">
                                              {name}
                                            </span>
                                        );
                                    } else {
                                        return <span className="item-text">&nbsp;</span>;
                                    }
                                }}
                            />
                        </Col>
                        <Col xs="auto">
                            {(!disabled && canRemove) && <Button
                                className="btn-transparent p-0 ml-1"
                                title="Odebrat"
                                onClick={() => {
                                    fields.remove(index)
                                }}>
                                <Icon icon={"trash-o"}/>
                            </Button>}
                            {add && !this.stepDone(step.approvers) && <Button
                                className="btn-transparent p-0 ml-1"
                                title="Přidat schvalovatele"
                                onClick={() => {
                                    fields.push({pracovnikId: null, flowId: null})
                                }}>
                                <Icon icon={"plus-square-o"}/>
                            </Button>}
                        </Col>
                    </Row>
                })}
            </div>
        );
    };

    renderSteps = ({fields}) => {
        const {submitting, steps} = this.props;
        return (
            <div>
                {fields.map((field, index) => {
                    if (steps) {
                        const step = steps[index];
                        return <Row noGutters className="step" key={index}>
                            <Col>
                                <ff.String label="" placeholder={'Popis'} name={field + ".name"} disabled={submitting}/>
                                <ff.Checkbox
                                    label={false}
                                    checkboxLabel="Schvalují všichni"
                                    name={field + ".everyone"}
                                    title="Schvalovatel je pouze ten, který si potvrdí převzetí. V opačném případně musí provést schválení všichni zmínění schvalovatelé."
                                    disabled={submitting}
                                />
                                <FieldArray name={field + ".approvers"} step={step}
                                            component={this.renderApprovers}/>
                            </Col>
                        </Row>
                    } else {
                        return <Loader key={index}/>;
                    }
                })}
            </div>
        );
    };

    render() {
        const {onClose, handleSubmit, submitting, steps} = this.props;
        return (
            <Form className="change-approvers-form" onSubmit={handleSubmit}>
                <FormBody>
                    <FieldArray name="steps" component={this.renderSteps}/>
                </FormBody>
                <FormActions onClose={onClose} disabled={submitting} submitButton="Uložit" cancelButton/>
            </Form>
        );
    }
}

function mapStateToProps(state) {
    const selector = formValueSelector(ChangeApproversForm.formName);
    return {steps: selector(state, "steps")};
}

const reduxFormObj = reduxForm({
    form: ChangeApproversForm.formName,
    validate: validate,
})(ChangeApproversForm);
export default connect(mapStateToProps)(reduxFormObj);
